const resource = {
	banner: [{
		tips: '资源',
		title: 'GPI',
		content: 'GPI是基于ISO14025 III型环境声明的原则和程序建立的管理规则，是中国有色金属行业EPD平台的运作基础。',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],
	tips_down: '资料下载:',
	dwon_CN: '中文资料下载',
	dwon_EN: '英文资料下载',
	empty: '暂无数据',
	tabList: [{
			id: '1',
			name: '环境绩效声明参数及标准',
			children: [],
		},
		{
			id: '2',
			name: '文献著作',
			children: [],
		},
		{
			id: '3',
			name: '模板',
			children: [],
		},
		{
			id: '4',
			name: '专家库',
			dec: '专家库介绍',
			children: [{
					id: '1',
					title: '钟掘',
					content: '钟掘（女），机械工程专家。1936年生于江西省南昌市，原籍河北省献县。1960年毕业于北京科技大学。中南大学教授。长期从事机械与制造工程的教学与科研。在轧制、锻、挤等金属塑性加工原理、工艺与装备的科学与工程研究中，注重探索大型复杂结构件材料流变的多尺度结构演变规律，研究材料与构件成形成性协同制造中的能量传递与转化规律，以获得高品质构件；进行系统动力学、复杂系统耦合与解耦设计理论、系统建模与仿真、系统辨识与故障诊断、残余应力与失效分析，塑性加工摩擦与润滑、新型材料制备机械研制等工作。其中较重要的是轧机驱动理论、高速轧机振动理论、冶金机械强度设计、现代高效材料制备技术与装备集成方面所取得的研究成果，发明了铝及铝合金的电磁铸轧技术与装备、在3万T模锻水压机功能升级、特宽铝板轧制线改扩建等多项材料加工生产的重大装备建设工程应用中取得实效。快速铸轧技术与装备，多次获得国家及省部级奖励，“变相驱动理论与技术开发”获1985年国家科技进步奖一等奖，“双机架铝热轧新技术开发”获1995年国家科技进步奖二等奖，“高性能特薄优质铝板”获1996年国家科技进步奖二等奖，“铝合金电磁铸轧技术与装备”获2002年国家技术发明二等奖，“铝资源高效利用与高性能铝材制造”获2007年国家科技进步一等奖。参加国家中长期科技发展规划战略研究，提出“极端制造”的概念与内涵，已被列入国家中长期科技发展规划。发表学术论文200余篇，专著4本。2002年获何梁何利科学技术奖。2000年被选为全国先进工作者。1995年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221111003_15386.jpg',
					avatar: require('@/assets/img/zjk/1.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '2',
					title: '何季麟',
					content: '何季麟，冶金与材料工程专家。1945年生于河南省开封市，原籍河南开封。1969年毕业于北京钢铁学院。现任中色西北稀有金属材料研究院名誉院长。曾任宁夏有色金属集团公司总工程师，中国有色金属学会副理事长。获冶金工程学士学位。何季麟同志长期从事有色、稀有金属冶炼与加工理论和工程化技术的研究开发工作。在稀有金属钽、铌、铍新材料领域取得了多项研究成果。研究开创了具有自主知识产权的钽铌金属冶炼、加工工艺、技术与方法并实现了工程化应用。主持并指导了特种铜合金、镁及镁合金、钛合金加工、钽电解电容器、电池材料、金属陶瓷靶材等多项新材料技术研究，在该领域主持实施了7项国家重点技改工程。 何季麟同志获授权专利9项，发表论文40余篇。获国家专利优秀奖1项。2007年“RTO金属包埋切片微米、纳米表征法”获“国家技术发明二等奖（R-03）”；2012年“超小型化钽电解电容器用关键材料生产技术与应用”获“国家科学技术进步二等奖（R-01）”；获省部级科技进步一等奖4项。荣获宁夏“科技明星”、“科学技术功勋奖”和“塞上英才”等奖励。1995年获全国劳动模范。2001年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221109031_80378.jpg',
					avatar: require('@/assets/img/zjk/2.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '3',
					title: '孙传尧',
					content: '孙传尧，原籍山东，1944年生于黑龙江省饶河县，佳木斯市人，男，汉族，矿物加工工程专家，俄罗斯圣.彼得堡工程科学院院士，全国劳动模范，中共党员。1968年毕业于东北工学院（现东北大学）有色冶金系选矿专业，1981年北京矿冶研究总院选矿专业研究生毕业，获工学硕士学位。曾在新疆可可托海矿务局从事稀有金属锂铍鉭鈮选矿工作，任选矿厂副厂长。曾任北京矿冶研究总院院长，现任矿物加工科学与技术国家重点实验室主任。兼任中国矿业联合会选矿委员会主任、中国有色金属学会选矿学术委员会主任。长期从事矿物加工及复杂多金属矿产资源综合利用的研究与设计工作，有丰富的选矿厂生产实践经验。在锂铍鉭鈮、铅锌、铜镍、钨铋钼，铁及黄金领域承担了多项科研任务，曾获国家科技进步二等奖4项，全国科学大会奖1项，省部级奖9项，获光华工程科技奖和有色金属科技进步特别贡献奖。发表学术论文150余篇。在理论研究中，与合作者共同开拓“矿物浮选的晶体化学原理”的学术方向，撰写出版学术专著《硅酸盐矿物浮选原理》。主编《选矿工程师手册》等大型专业书6部。培养博士研究生45人。近年来，提出“开发与矿物资源可选性相和谐的精细工艺技术（和谐选矿）和基因矿物加工工程（基因选矿）的学术观点。2003年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221107038_43575.jpg',
					avatar: require('@/assets/img/zjk/3.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '4',
					title: '邱冠周',
					content: '邱冠周，矿物工程学家。广东省梅州市人。1987年9月毕业于中南工业大学矿物加工工程专业，获博士学位。曾任中南工业大学副校长、中南大学副校长，现任中南大学教授、博士生导师。长期致力于我国低品位、复杂难处理金属矿产资源加工利用研究，在细粒及硫化矿物浮选分离和铁矿直接还原等方面取得显著成绩，特别是在低品位硫化矿的生物冶金方面做出突出贡献，被授予国家有突出贡献科技专家。发表了97篇科技论文和5部专著，先后获得国家技术发明二等奖2项，国家科技进步二等奖1项，国家科技进步一等奖1项，中国高等学校十大科技进展2项；2003年担任国家自然科学基金创新群体学术带头人，2004年、2009年连续两次担任生物冶金领域国家973计划项目首席科学家，担任2011年第19届国际生物冶金大会主席，并被推选为国际生物冶金学会副会长。2011年当选中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221106020_50416.jpg',
					avatar: require('@/assets/img/zjk/4.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '5',
					title: '段宁',
					content: '段宁，清洁生产专家。四川省成都市人。1975年毕业于同济大学给排水及暖通工程系，1981年获清华大学环境工程系硕士学位，1988年获美国德克萨斯州立大学奥斯汀分校土木工程系博士学位。现任中国环境科学研究院重金属清洁生产工程技术中心主任，曾任中国环境科学研究院副院长、环境保护部清洁生产中心主任。中国生态经济学会工业生态经济与技术专业委员会副理事长，中国工业节能与清洁生产协会副会长。2011年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221102053_82176.jpg',
					avatar: require('@/assets/img/zjk/5.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '6',
					title: '蔡美峰',
					content: ' 蔡美峰，岩石力学与采矿工程专家。江苏省如东县人。1967年毕业于上海交通大学，1990年获新南威尔士大学采矿岩石力学博士学位。曾任北京科技大学土木与环境工程学院院长、国际岩石力学学会教育委员会主席，现任北京科技大学教授、国务院学位委员会矿业工程学科评议组召集人。我国矿山地应力测量的主要开拓者之一，首次开发出我国具有自主知识产权的地应力测量技术，提出了以地应力为基础的采矿设计优化的技术体系、安全高效开采技术和矿山动力灾害预测与防控技术。曾获国家科技进步二等奖3项，三等奖1项，国家技术发明三等奖1项，已出版学术专著4部、发表学术论文150余篇，培养博士后20多名、博士90多名，硕士50多名，主编“十五”国家级规划教材1部，获国家级教学成果二等奖1项。2013年当选中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221047032_63709.jpg',
					avatar: require('@/assets/img/zjk/6.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '7',
					title: '桂卫华',
					content: ' 桂卫华，1950年生于武汉，男，汉族，湖北省武汉市人，自动控制专家。中共党员。1975年毕业于中南矿冶学院工业企业电气化及自动化专业，1981年获得中南矿冶学院工业自动化专业硕士学位，1986年赴德国Duisburg大学自动控制专业做访问学者两年，曾任中南大学信息科学与工程学院院长，现任中南大学控制工程研究所所长、中国有色金属学会副理事长、中国自动化学会副理事长、湖南省自动化学会名誉理事长。长期致力于流程工业生产过程控制理论、技术和工程应用的研究，围绕流程工业企业信息化和智能制造的技术问题，创建了以智能集成为核心的复杂有色冶金过程建模、控制与优化的理论与方法。成果主要应用在有色金属行业的多家大型企业，获得显著的经济效益和社会效益，为我国流程工业的快速发展、特别是自动化技术的提升和自主创新作出了重要贡献。其研究成果获国家科技进步二等奖3项，省部级科技奖励13项；获“何梁何利基金科学与技术进步奖”、“湖南光召科技奖”、“中国有色金属工业优秀科技工作者”、“中国过程控制技术贡献奖”、“杨嘉墀科技奖”等荣誉称号；出版专著5部等。执教三十余年，获得“全国优秀科技工作者”、“全国优秀教师”荣誉称号。作为学术带头人，带领科研团队于2013年成为国家自然科学基金创新研究群体，2016年创新群体以整体优秀结题并获得国家自然科学基金委滚动支持。2013年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221046004_48353.jpg',
					avatar: require('@/assets/img/zjk/7.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '8',
					title: '丁文江',
					content: '丁文江，轻合金研究专家。1953年生于上海市,原籍浙江绍兴。1981年毕业于上海交通大学铸造专业。现任轻合金精密成型国家工程研究中心主任。曾任上海交通大学副校长、上海市科委副主任。在国际上担任或曾担任：世界轻合金联盟轮值主席，中挪（中国和挪威）轻合金研究中心中方主席；日本九州大学外部评价委员；澳大利亚莫纳什大学顾问；美国通用—交大先进材料制造联合实验室主任。长期从事先进镁合金材料及其精密成形研究，把镁与稀土相结合，开展系统研究，形成中国特色，迄今为止，在镁研究领域发表SCI论文308篇（其中3篇入选近10年ESI高引用论文），累计他引2469次，拥有发明专利114项，作为第一获奖人，2003年获国家科技进步二等奖，2006年获国家技术发明奖二等奖、2007年获上海市技术发明一等奖；创建了国家工程中心，凝聚三百余人的研发队伍，实现了基础研究，应用开发，工程化和技术转移的良性互动。全国国家工程研究中心二次评优并获国家工程中心20年重大成就奖。2010年获全国优秀科技工作者称号。2013年当选为中国工程院院士。',
					img: 'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221040023_91994.jpg',
					avatar: require('@/assets/img/zjk/8.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
			]
		},
		{
			id: '5',
			name: '项目库',
			dec: '项目库介绍',
			children: [{
					id: '1',
					title: '氧气底吹连续炼铜技术',
					time: '',
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>氧气底吹连续炼铜技术是中国恩菲在国家863计划项目的支持下，产学研联合攻关，开发出的新一代先进铜冶炼技术。氧气底吹熔炼炉、氧气底吹连续吹炼炉和阳极精炼炉采用流槽连接，熔体通过流槽转运，全热态生产，实现全流程连续炼铜。熔炼炉和吹炼炉水冷原件少，采用高富氧，完全依靠化学反应热实现自热冶炼，无需补充煤等燃料，吹炼炉可处理大量高含铜物料。</p><p>底吹炉冷却元件少，炉体散热极小，冶炼过程无需加煤，吨铜年减排二氧化碳约200-400千克，按照全国600万吨矿铜计，二氧化碳年减排120万吨-240万吨，碳减排潜力较大。</p>`,
					img: require('@/assets/img/resource/1.png'),
					content_2:'<p>底吹炉冷却元件少，炉体散热极小，冶炼过程无需加煤，吨铜年减排二氧化碳约200-400千克，按照全国600万吨矿铜计，二氧化碳年减排120万吨-240万吨，碳减排潜力较大。<p>',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '2',
					title: '低温废热回收耦合多效蒸发深度处理工业废水零排放技术',
					time: "2023",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>通过多点废热回收，采用低温相变-梯级用热、钙体系长周期不结垢等对复杂难处理高盐高钙废水进行定向固液深度浓缩、分离处理，用少量余热输入，得到多倍于加热汽量的蒸馏水的脱盐技术。实现“以废热治废水”和“节水减排降碳”目标，使低品位热源得到梯级多功效利用，极大降低复杂工业废水零排处理成本及高品质淡水生产成本，广泛用于化水制备和高盐高钙、高氨氮等工业废水低温浓缩和低温蒸发结晶。</p><p>预计到2030年，应用该技术年处理废水22150万m3/a，实现年碳减排潜力1198万吨CO2/a，较行业平均水平下降67.72%。</p>`,
					img: require('@/assets/img/resource/2.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '3',
					title: '碳酸氢镁法分离提纯稀土新技术',
					time: "2023",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>稀土分离提纯过程产生的氯化镁、硫酸镁废液采用廉价的石灰或轻烧白云石碱转、回收的CO2碳化高效自制碳酸氢镁溶液，循环用于稀土萃取分离，革除了大量液氨、液碱、氧化镁等消耗，镁盐、CO2气体及水循环利用率大于90%，从源头解决稀土萃取分离过程的氨氮或高盐废水处理难题，成本大幅降低。</p><p>目前已应用该技术的产能达6.6万吨REO/年（占国内总产能25%以上），实现碳减排10万吨/年；预计到2025年，应用该技术的总产能达12万吨REO/年，可实现碳减排18万吨/年。</p>`,
					img: require('@/assets/img/resource/3.png'),
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '4',
					title: '新型稳流保温铝电解槽节能技术开发与推广应用',
					time: "",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '5',
					title: '铝电解槽低碳长龄复合阴极技术与装备',
					time: "2023",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '6',
					title: '铝电解多参数平衡智能控制技术与装备',
					time: "",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '7',
					title: '无炭渣预焙阳极技术开发及产业化应用',
					time: "2023",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '8',
					title: '侧吹熔炼加多枪顶吹吹炼连续炼铜技术',
					time: "2023",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '9',
					title: '大型竖罐底出渣双蓄热镁还原技术',
					time: "",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},
				{
					id: '10',
					title: '大型还原蒸馏联合炉生产海绵钛工艺技术',
					time: "",
					unit: '',
					concant: '',
					phone: '',
					email: '',
					subject: '',
					content: `<p>详细内容陆续更新中。</p>`,
					img: '',
					tips: '',
					dwon_CN: '',
					dwon_EN: '',
					dwon_url_CN: '',
					dwon_url_EN: ''
				},		
			]
		},
		{
			id: '6',
			name: 'EPD/CFP工具',
			dec: `开展EPD /CFP验证宜使用平台提供的中国有色金属行业EPD/CFP工具（简称 “CNIA-EPD/CFP tool”）完成，以加快EPD开发进程。CNIA-EPD/CFP tool提供适应不同有色金属产品PCR的数据采集与验证工具，可适用于各类有色金属冶炼、加工企业开展EPD /CFP验证。`,
			dec_2:`CNIA-EPD tool所使用的LCA模型对潜在的材料和/或产品组件进行了参数化处置，允许CNIA-EPD tool使用者修改一个预定义的数据输入项，或从一个预定义的产品组件菜单中选择并关联到某个特定的产品以生成一个特定的EPD。CNIA-EPD tool使用者不能对LCA模型和菜单进行修改。CNIA-EPD tool输出的参数结果清单正是EPD所需的。CNIA-EPD tool的使用者可通过选择菜单选项和计算参数结果，自动生成EPD。`,
			children: []
		}
	]
}

export default resource